var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBpayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 -1.66103e-06C1.59315 -1.80588e-06 0.25 1.34314 0.25 3L0.25 19C0.25 20.6569 1.59315 22 3.25 22L19.25 22C20.9069 22 22.25 20.6569 22.25 19L22.25 3C22.25 1.34314 20.9069 -2.02477e-06 19.25 -2.16962e-06L3.25 -1.66103e-06ZM11.4784 6.54329C10.4351 6.54329 9.45692 6.82222 8.61438 7.30957L8.61439 4.79328C8.61439 4.00236 7.97322 3.36119 7.1823 3.36119C6.39138 3.36119 5.75021 4.00236 5.75021 4.79328L5.75021 12.2331L5.75008 12.2716L5.75021 12.3102L5.75021 12.7493C5.75021 12.9119 5.77728 13.0681 5.82717 13.2137C6.27646 15.9292 8.63561 18 11.4784 18C14.6421 18 17.2068 15.4353 17.2068 12.2716C17.2068 9.10796 14.6421 6.54329 11.4784 6.54329ZM11.4786 9.40737C9.89676 9.40737 8.61442 10.6897 8.61442 12.2715C8.61442 13.8534 9.89676 15.1357 11.4786 15.1357C13.0604 15.1357 14.3428 13.8534 14.3428 12.2716C14.3428 10.6897 13.0604 9.40737 11.4786 9.40737Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpayIcon);
export default __webpack_public_path__ + "static/media/bpay_icon.5070d7e69fc786162636f2ca5a98f44a.svg";
export { ForwardRef as ReactComponent };